// extracted by mini-css-extract-plugin
module.exports = {"container":"ApplicationLabels_container__8p0j3","label":"ApplicationLabels_label__lcHjV"};